import pathsManifest from 'app/shared/utils/pathsManifest';

import type { Market } from 'app/shared/types/Market';
import type { TopMarketsApiType } from 'app/shared/types/ApiResponseTypes';

export function decorate(market: Market, queryString: string) {
  return { ...market, url: market.url + queryString };
}

class TopMarkets {
  topRentalMarkets: Array<Market>;

  constructor(res: TopMarketsApiType = <TopMarketsApiType>{}) {
    const topRentalMarkets = res?.topRentalMarkets ?? [];
    this.topRentalMarkets = topRentalMarkets.map((topMarket) => {
      return {
        url: `${pathsManifest.MarketTrendsPage}/${topMarket.resourceId}/`,
        resourceId: topMarket.resourceId,
        name: topMarket.areaName,
        medianRent: topMarket.medianRent,
        prices: topMarket.medianRentPriceOverTime.map(({ price }) => price),
      };
    });
  }
}

export default TopMarkets;
